var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c("el-page-header", {
        attrs: { content: "批次详情" },
        on: {
          back: function ($event) {
            return _vm.$router.go(-1)
          },
        },
      }),
      _c("div", { staticClass: "ac_tabs" }, [
        _c(
          "div",
          { staticClass: "ac_tabs-contain" },
          [
            _c(
              "el-descriptions",
              { attrs: { column: 4, size: "small", border: "" } },
              [
                _c("el-descriptions-item", { attrs: { label: "批次名称" } }, [
                  _vm._v(_vm._s(_vm.info.batchName)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "批次Id" } }, [
                  _vm._v(_vm._s(_vm.info.batchId)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "状态" } }, [
                  _vm._v(_vm._s(_vm.info.status)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "创建人" } }, [
                  _vm._v(_vm._s(_vm.info.userName)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "创建时间" } }, [
                  _vm._v(_vm._s(_vm.info.creatTime)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "所属公司" } }, [
                  _vm._v(_vm._s(_vm.info.company)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "有效期" } }, [
                  _vm._v(_vm._s(_vm.info.validDate)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "用途" } }, [
                  _vm._v(_vm._s(_vm.info.use)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "批次总金额" } }, [
                  _vm._v(_vm._s(_vm.info.totalAmount)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "已绑定金额" } }, [
                  _vm._v(_vm._s(_vm.info.bindAmount)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "已发放金额" } }, [
                  _vm._v(_vm._s(_vm.info.issueAmount)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "已核销金额" } }, [
                  _vm._v(_vm._s(_vm.info.verAmount)),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "ac_tabs" }, [
        _c("div", { staticClass: "ac_tabs_nav-wrap" }, [
          _c("div", { staticClass: "ac_tabs-items" }, [
            _c("span", [_vm._v("礼包")]),
            _c(
              "span",
              { staticStyle: { "padding-left": "20px" } },
              [
                _vm.info.status !== "已作废"
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["coupon_gift_add"],
                            expression: "['coupon_gift_add']",
                          },
                        ],
                        attrs: {
                          type: "success",
                          size: "mini",
                          icon: "el-icon-plus",
                        },
                        on: { click: _vm.handleCouponPkgCreate },
                      },
                      [_vm._v("新增礼包")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "ac_tabs-contain" },
          [
            _c(
              "yd-table",
              {
                attrs: {
                  loading: _vm.loading,
                  data: _vm.data,
                  size: "mini",
                  border: "",
                  "max-height": "320",
                  pagination: _vm.page,
                },
                on: { onChange: _vm.onTableChange },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "礼包ID",
                    width: "150",
                    prop: "giftBagId",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "礼包名称",
                    prop: "giftBagName",
                    width: "200",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handlePkgView(scope.row.giftBagId)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.giftBagName))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "金额/个", prop: "amount", align: "center" },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "已绑定金额",
                    prop: "bindAmount",
                    width: "100",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "礼包数量",
                    prop: "giftBagNum",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "剩余",
                    prop: "remainGiftBagNum",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "券组成", prop: "coupon", align: "center" },
                }),
                _c("el-table-column", {
                  attrs: { label: "创建人", prop: "userName", align: "center" },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "创建时间",
                    prop: "creatTime",
                    width: "180",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "状态",
                    prop: "giftBagStatus",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "120", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.stateCode !== 2
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: ["coupon_gift_delete"],
                                      expression: "['coupon_gift_delete']",
                                    },
                                  ],
                                  attrs: { size: "mini", type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleZuofeipici(
                                        scope.row.giftBagId
                                      )
                                    },
                                  },
                                },
                                [_vm._v("作废")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "YdDialog",
        {
          attrs: {
            title: "新增礼包",
            visible: _vm.visible,
            width: "50%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                size: "small",
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "礼包名称：", prop: "giftName" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入礼包名称",
                      clearable: "",
                      maxlength: "20",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.giftName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "giftName", $$v)
                      },
                      expression: "form.giftName",
                    },
                  }),
                  _c(
                    "span",
                    [
                      _vm._v("\n          内部优惠券是否可拆分\n          "),
                      _c("avue-switch", {
                        attrs: { dic: [{ value: 2 }, { value: 1 }] },
                        on: { change: _vm.switchChange },
                        model: {
                          value: _vm.form.split,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "split", $$v)
                          },
                          expression: "form.split",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "tipsBox" }, [
                    _c("div", [_vm._v("提示：")]),
                    _c("div", [
                      _c("span", [
                        _vm._v("发放优惠券：按钮开启、礼包可拆分！"),
                      ]),
                      _c("br"),
                      _c("span", [_vm._v("发放礼包：按钮关闭、礼包不可拆分")]),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "创建数量：", prop: "giftNum" } },
                [
                  _c("avue-input-number", {
                    attrs: { disabled: _vm.form.split === 1 },
                    model: {
                      value: _vm.form.giftNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "giftNum", $$v)
                      },
                      expression: "form.giftNum",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "danger" },
                  on: { click: _vm.reset },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.pkgLoading,
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }